import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import Section from 'components/common/Section';
import SectionHeader from './SectionHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const benefitKeys = [
  { icon: 'bolt', titleKey: 'BENEFIT_FAST_TITLE', descKey: 'BENEFIT_FAST_DESC' },
  { icon: 'tasks', titleKey: 'BENEFIT_CONTROL_TITLE', descKey: 'BENEFIT_CONTROL_DESC' },
  { icon: 'lock', titleKey: 'BENEFIT_SECURE_TITLE', descKey: 'BENEFIT_SECURE_DESC' }
];

const Processes = () => {
  const { t } = useTranslation();

  return (
    <Section id="benefits">
      <SectionHeader
        title={t('LANDING.BENEFITS_TITLE')}
        subtitle={t('LANDING.BENEFITS_SUBTITLE')}
      />
      <Row className="mt-6">
        {benefitKeys.map((benefit, index) => (
          <Col md={4} key={index} className="mb-4">
            <Card className="h-100 shadow-sm border-0 p-4 text-center">
              <Card.Body>
                <div
                  className="rounded-circle bg-soft-primary d-inline-flex align-items-center justify-content-center mb-3"
                  style={{ width: 64, height: 64 }}
                >
                  <FontAwesomeIcon icon={benefit.icon} className="text-primary fs-3" />
                </div>
                <h5 className="mb-2">{t(`LANDING.${benefit.titleKey}`)}</h5>
                <p className="text-600 mb-0">{t(`LANDING.${benefit.descKey}`)}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Section>
  );
};

export default Processes;
